export default __webpack_public_path__ + "static/media/fourByFour.0f5f1da6.svg";